import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table for balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'UserId', // Column ID
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BetId',
                                    header: _('ID Apuesta'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'CampaignType',
                                    header: _('Tipo de campaña'),
                                    width: 200,
                                    sort: 'int',
                                    /**
                                     * Template function to display campaign type based on its value.
                                     * @param {Object} obj - The data object for the row.
                                     * @returns {String} The display string for the campaign type.
                                     */
                                    template: function (obj) {
                                        return obj.CampaignType === '0'
                                            ? 'Bono'
                                            : obj.CampaignType === '1'
                                              ? 'Torneo'
                                              : obj.CampaignType == '2'
                                                ? 'Sorteo'
                                                : obj.CampaignType;
                                    },
                                },
                                {
                                    id: 'CampaignId',
                                    header: _('ID Campaña'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'BetAmount',
                                    header: _('Valor de la Apuesta'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'ConvertedAmount',
                                    header: _('Valor convertido en la Campaña'),
                                    width: 200,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                /**
                                 * Event handler for before loading data into the datatable.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event handler for after loading data into the datatable.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                },
                            },
                            /**
                             * Event handler for when the datatable is ready.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'Report/GetBetsByCampaignReport'; // API endpoint for fetching bets
        var filter = ''; // Filter string for API requests

        // Event listener for filtering data
        this.on(this.app, 'balanceAdjustments:filter', (filterData) => {
            /**
             * Builds the query URL with filters.
             * @param {String} baseUrl - The base URL for the API.
             * @param {Object} filters - The filters to apply.
             * @returns {String} The constructed query URL.
             */
            function buildQueryUrl(baseUrl, filters) {
                const params = [];
                Object.entries(filters).forEach(([key, value]) => {
                    if (key.includes('Datepicker') && value != '' && value != undefined) {
                        let date = value.split(' - ');
                        params.push(`dateFrom=${date[0]}&dateTo=${date[1]}`);
                    } else if (value !== '') {
                        params.push(`${key}=${encodeURIComponent(value)}`);
                    }
                });
                params.push('TypeBet=1'); // Add fixed parameter
                return `${baseUrl}&${params.join('&')}`; // Construct and return the full URL
            }
            const queryUrl = buildQueryUrl(url + '?start=0&count=' + grid.data.$pagesize, filterData);
            grid.clearAll(); // Clear existing data in the grid
            grid.load(queryUrl); // Load new data based on the query URL
        });

        // Popup for adding a new transaction
        var popupAdd = webix.ui({
            view: 'window',
            id: 'Add', // Unique identifier for the popup
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            body: {
                view: 'form',
                id: 'addform', // Unique identifier for the form
                elements: [
                    {
                        view: 'text',
                        label: _('Id torneo'), // Label with localization
                        labelWidth: 140,
                        name: 'IdTournament', // Name of the input field
                        type: 'number', // Input type
                        required: true, // Mark as required
                    },
                    {
                        view: 'text',
                        label: _('Id transacción'),
                        labelWidth: 140,
                        name: 'IdTransaction',
                        type: 'number',
                        required: true,
                    },
                    {
                        view: 'combo',
                        label: _('Tipo campaña:'),
                        name: 'Type',
                        required: true,
                        labelPosition: 'top',
                        options: [
                            { id: '2', value: _('Casino') }, // Option for Casino
                            { id: '3', value: _('Casino en vivo') }, // Option for Live Casino
                            { id: '4', value: _('Virtuales') }, // Option for Virtuals
                        ],
                        labelWidth: 150,
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Ingresar'), // Submit button
                                click: function ($e) {
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        var values = $$('addform').getValues(); // Get form values
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Bonus/AddTransactionToTournament', // API endpoint for adding transaction
                                                '{"IdTournament":"' +
                                                    values.IdTournament +
                                                    '", "IdTransaction":"' +
                                                    values.IdTransaction +
                                                    '", "Type":"' +
                                                    values.Type +
                                                    '", "QueryType":"' +
                                                    0 +
                                                    '"}', // JSON payload
                                                {
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var data = JSON.parse(text); // Parse response
                                                        if (data.AlertType == 'error' || data.AlertType == 'danger') {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _(data.AlertMessage), // Display error message
                                                            });
                                                        } else {
                                                            popupConfirmAdd.show(); // Show confirmation popup
                                                            popupAdd.hide(); // Hide add popup
                                                        }
                                                    },
                                                },
                                            );
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Display validation error
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Confirmation popup for adding a transaction
        var popupConfirmAdd = webix.ui({
            view: 'window',
            id: 'Add', // Unique identifier for the confirmation popup
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                            webix.message({
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: _('Proceso cancelado.'), // Display cancellation message
                            });
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            body: {
                view: 'form',
                id: 'addconfirmform', // Unique identifier for the confirmation form
                elements: [
                    {
                        /**
                         * Template function to display confirmation message.
                         * @returns {String} The confirmation message.
                         */
                        template: function () {
                            var values = $$('addform').getValues(); // Get values from the add form
                            return `La transaccion con ID ${values.IdTransaction} es viable para participar en el torneo con ID ${values.IdTournament}. ¿Desea ingresar esta apuesta a participar?`;
                        },
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                    webix.message({
                                        title: _('¡Error!'),
                                        type: 'alert-error',
                                        text: _('Proceso cancelado.'), // Display cancellation message
                                    });
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Aceptar'), // Accept button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get values from the add form
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Bonus/AddTransactionToTournament', // API endpoint for adding transaction
                                            '{"IdTournament":"' +
                                                values.IdTournament +
                                                '", "IdTransaction":"' +
                                                values.IdTransaction +
                                                '", "Type":"' +
                                                values.Type +
                                                '", "QueryType":"' +
                                                1 +
                                                '"}', // JSON payload
                                            {
                                                success: function (text, data, XmlHttpRequest) {
                                                    if (data.AlertType == 'error') {
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _(data.AlertMessage), // Display error message
                                                        });
                                                    } else {
                                                        webix.message({
                                                            text: _('Ingreso exitoso'),
                                                            title: _('¡Exito!'),
                                                            type: 'alert-warning', // Display success message
                                                        });
                                                        grid.clearAll(); // Clear the grid
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    }
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide the confirmation popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event listener for showing the add bet popup
        this.on(this.app, 'addBet:button', (filter) => {
            popupAdd.show(); // Show the add popup
        });
    }
}

// FILE DOCUMENTED
